///
/// EarthBrowser
///
/// Created by Matt Giger
/// Copyright (c) 2025 Geodata Labs
///

/**
 * Global z-depth constants for info panels.
 * Lower values are farther from the orthographic camera.
 * Higher values are closer to the camera.
 *
 * These depths ensure proper layering when multiple info panels are visible.
 */
export class PanelDepths {
	/** Crosshair - behind all info panels */
	public static readonly CROSSHAIR = 0.25

	/** Connector overlays - should be behind panels */
	public static readonly CONNECTOR = 0.5

	/** Location info panels - farthest from camera (lowest priority) */
	public static readonly LOCATION = 1

	/** Volcano info panels - middle depth */
	public static readonly VOLCANO = 2

	/** Quake info panels - middle depth */
	public static readonly QUAKE = 2.5

	/** Buoy info panels - middle depth */
	public static readonly BUOY = 2.5

	/** Satellite info panels - closest to camera (highest priority) */
	public static readonly SATELLITE = 3
}
